/** コンサルタント：案件詳細ページサイドバーの「提案数・競争率予測MEMO」への導線 */
export const SHOW_PROFESSIONAL_RFP_PREDICT_MEMO_CARD = false;
